exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table td[data-v-225a55c8]{padding:5px .75rem}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/client/Customization.vue"],"names":[],"mappings":"AACA,2BACE,kBAAqB,CACtB","file":"Customization.vue","sourcesContent":["\n.table td[data-v-225a55c8] {\n  padding: 5px 0.75rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-225a55c8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/client/Customization.vue
// module id = 1961
// module chunks = 0